<template>
  <div>
    <ContentHeader title="Bank Account" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-danger">
              <div class="card-header">
                <h3 class="card-title">Add New Bank Account</h3>
              </div>
              <!-- /.card-header -->
              <!-- form start -->
              <form @submit.prevent="handleCreateData()">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="bank-name" class="col-sm-2 col-form-label"
                      >Bank Name</label
                    >
                    <div class="col-sm-10 mb-3">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"
                            ><i class="fas fa-university"></i
                          ></span>
                        </div>
                        <select
                          class="form-control"
                          v-model="payload.bank_name"
                          :class="{
                            'border-danger':
                              $v.payload.bank_name.$error &&
                              payload.bank_name == '',
                          }"
                        >
                          <option
                            :value="bank.name"
                            v-for="bank in bank_list"
                            :key="bank.index"
                          >
                            {{ bank.name }}
                          </option>
                        </select>
                      </div>
                      <div
                        class="text-danger"
                        v-if="
                          $v.payload.bank_name.$error && payload.bank_name == ''
                        "
                      >
                        <small>Bank Name Required</small>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="owner-name" class="col-sm-2 col-form-label"
                      >Owner Name</label
                    >
                    <div class="col-sm-10 mb-3">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"
                            ><i class="far fa-id-card"></i
                          ></span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          id="owner-name"
                          placeholder="Enter Owner Name"
                          v-model="payload.owner_name"
                          :class="{
                            'border-danger': $v.payload.owner_name.$error,
                          }"
                        />
                      </div>
                      <div
                        class="text-danger"
                        v-if="$v.payload.owner_name.$error"
                      >
                        <small>Owner Name Required</small>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="account-number" class="col-sm-2 col-form-label"
                      >Account Number</label
                    >
                    <div class="col-sm-10 mb-3">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"
                            ><i class="far fa-credit-card"></i
                          ></span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          id="account-number"
                          placeholder="Enter Account Number"
                          v-model="payload.account_number"
                          :class="{
                            'border-danger':
                              $v.payload.account_number.$error ||
                              !$v.payload.account_number.numeric,
                          }"
                        />
                      </div>
                      <div
                        class="text-danger"
                        v-if="
                          $v.payload.account_number.$error &&
                          !$v.payload.account_number.required
                        "
                      >
                        <small>Account Number Required</small>
                      </div>
                      <div
                        class="text-danger"
                        v-if="!$v.payload.account_number.numeric"
                      >
                        <small>Account Number must be a number</small>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="branch-name" class="col-sm-2 col-form-label"
                      >Branch Name</label
                    >
                    <div class="col-sm-10 mb-3">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"
                            ><i class="fas fa-map-marked-alt"></i
                          ></span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          id="branch-name"
                          placeholder="Enter Branch Name"
                          v-model="payload.branch_name"
                          :class="{
                            'border-danger': $v.payload.branch_name.$error,
                          }"
                        />
                      </div>
                      <div
                        class="text-danger"
                        v-if="$v.payload.branch_name.$error"
                      >
                        <small>Branch Name Required</small>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.card-body -->
                <div class="card-footer">
                  <router-link :to="{ name: 'Bank' }" class="btn btn-default mr-1">
                    Cancel
                  </router-link>
                  <button
                    type="submit"
                    class="btn btn-danger float-right ml-1"
                    :disabled="submitStatus === 'PENDING'"
                  >
                    Add Bank Account
                  </button>
                </div>
                <!-- /.card-footer -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import { required, numeric } from "vuelidate/lib/validators";
import apiClient from "@/services/ApiServices";
import axios from "axios";

export default {
  data() {
    return {
      payload: {
        bank_name: "BANK MANDIRI",
        owner_name: "",
        account_number: "",
        branch_name: "",
      },
      submitStatus: "",
      bank_list: [],
    };
  },

  components: {
    ContentHeader,
  },
  validations: {
    payload: {
      bank_name: {
        required,
      },
      owner_name: {
        required,
      },
      account_number: {
        required,
        numeric,
      },
      branch_name: {
        required,
      },
    },
  },
  created() {
    document.title = "Add Account - Manager Cabang";
  },
  async mounted() {
    try {
      let bankList = await axios.get(process.env.VUE_APP_BANK_BASE_URL);
      this.bank_list = bankList.data.data;
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.data.data.message,
        "error"
      );
    }
  },
  methods: {
    handleCreateData() {
      this.isDisabled = true;
      let data = new FormData();

      data.append("corporate_partner_id", this.$store.getters.user.id);
      data.append("bank_name", this.payload.bank_name);
      data.append("owner_name", this.payload.owner_name);
      data.append("account_number", this.payload.account_number);
      data.append("branch_name", this.payload.branch_name);

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";
        apiClient
          .post("bank/", data)
          .then(() => {
            this.$swal(
              "Added!",
              "New Bank account has been added.",
              "success"
            ).then(() => {
              this.$router.push({ name: "Bank" });
            });
            this.submitStatus = "OK";
          })
          .catch(() => {
            this.submitStatus = "ERROR";
          });
      }
    },
    logout() {
      this.$store.dispatch("logout");
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
